import { render, staticRenderFns } from "./ServicesLiveSearch.vue?vue&type=template&id=31c2c45e&scoped=true&"
import script from "./ServicesLiveSearch.vue?vue&type=script&lang=js&"
export * from "./ServicesLiveSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2c45e",
  null
  
)

export default component.exports